import React from 'react';
import Specials from '../components/Specials/Specials';

const SpecialsPage = () => {
  return (
    <div style={{ marginTop: '151px', minHeight: '100vh' }}>
      <Specials />
    </div>
  );
};

export default SpecialsPage;
